import React from 'react';
import { useTranslation } from 'react-i18next';
import phone from '../../../assets/icons/info/phone.svg';
import email from '../../../assets/icons/info/email.svg';
import website from '../../../assets/icons/info/website.svg';
import facebook from '../../../assets/icons/social-networks/facebook.svg';
import instagram from '../../../assets/icons/social-networks/instagram.svg';
import './Footer.scss';

export default function Footer() {
  const { t } = useTranslation('footer');

  const availableWindowWidth = document.documentElement.clientWidth;

  return (
    <footer className="Footer">
      <div className="wrapper">
        <div className="footer-content">
          {
            availableWindowWidth > 601
              ? (
                <>
                  <p className="copyright">
                    {t('copyright')}
                  </p>
                  <p className="address">
                    {t('address')}
                  </p>
                </>
              )
              : (
                <div className="grouped-elements">
                  <p className="copyright">
                    {t('copyright')}
                  </p>
                  <p className="address">
                    {t('address')}
                  </p>
                </div>
              )
          }
          <div className="contact-list">
            <div className="contact-list__item">
              <img
                className="info-icon"
                src={phone}
                alt="phone"
              />
              <a
                href="tel:+380342523347"
              >
                0342 52 33 47
              </a>
            </div>
            <div className="contact-list__item">
              <img
                className="info-icon"
                src={email}
                alt="email"
              />
              <a
                href="mailto:info@cci.if.ua"
              >
                info@cci.if.ua
              </a>
            </div>
            <div className="contact-list__item">
              <img
                className="info-icon"
                src={website}
                alt="website"
              />
              <a
                href="/"
              >
                www.cci.if.ua
              </a>
            </div>
          </div>
          <div className="social-networks">
            <a
              href="https://www.facebook.com/cci.if.ua/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={facebook}
                alt="facebook"
              />
            </a>
            <a
              href="https://www.instagram.com/if.cci.ua/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={instagram}
                alt="instagram"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
